import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContatosService} from '../../../services/contatos.service';
import {SEGMENTOS_CRM, SegmentoCrm} from '../crm-segmentos';

interface ItemPublico extends SegmentoCrm {
  qtde: number;
  qtdeRecebeMensagem: number;
}

/**
 * Segmentos do CRM como público de campanha. Em "atalhos" (lista de campanhas) cada cartão
 * abre uma campanha nova; em "seletor" (tela da campanha) escolhe o público na hora.
 */
@Component({
  selector: 'app-publico-segmento-crm',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './publico-segmento-crm.component.html',
  styleUrls: ['./publico-segmento-crm.component.scss']
})
export class PublicoSegmentoCrmComponent implements OnInit {
  @Input() modo: 'atalhos' | 'seletor' = 'seletor';
  @Input() selecionado: string = null;
  @Input() desabilitado = false;
  @Output() selecione = new EventEmitter<string>();

  itens: ItemPublico[] = SEGMENTOS_CRM.map(s => ({...s, qtde: 0, qtdeRecebeMensagem: 0}));
  carregado = false;

  constructor(private contatosService: ContatosService) {}

  ngOnInit(): void {
    this.contatosService.obtenhaResumoCrm().then((dados: any) => {
      const linhas: any[] = dados.segmentos || [];
      this.itens = SEGMENTOS_CRM.map(segmento => {
        const linha = linhas.find(l => l.status === segmento.codigo) || {};
        return {...segmento, qtde: Number(linha.qtde) || 0, qtdeRecebeMensagem: Number(linha.qtdeRecebeMensagem) || 0};
      });
    }).catch(() => {}).finally(() => this.carregado = true);
  }

  /** Na lista de campanhas, os segmentos que valem uma campanha agora vêm primeiro. */
  get itensVisiveis(): ItemPublico[] {
    return this.modo === 'atalhos' ? this.itens.filter(item => item.codigo !== 'SEM_PEDIDO' || item.qtdeRecebeMensagem > 0) : this.itens;
  }

  escolha(item: ItemPublico): void {
    if (this.desabilitado || !item.qtdeRecebeMensagem) return;
    this.selecione.emit(item.codigo);
  }

  numero(valor: number): string {
    return (Number(valor) || 0).toLocaleString('pt-BR');
  }
}
